import { Observable } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { GenericRepository } from "../../generic-repository/GenericRepository";
import { ResponseModel } from "../../../models/SharedModels/response.model";
import { environment } from "../../../../environments/environment";
import { IEmployeePointRepository } from "./IEmployeePointRepository";

@Injectable()
export class EmployeePointRepository extends GenericRepository<any> implements IEmployeePointRepository {
 
  url: string = environment.urlAddress;
  constructor(protected _http: HttpClient) {
      super(_http, 'api/EmployeePoints', environment.urlAddress);
    }   
    GetEmployeePoints(employeeCode: string, fromDate: string, toDate: string): Observable<any> {      
        return this.Get('/GetEmployeePoints' + '/' + employeeCode + '/' + fromDate + '/' + toDate).pipe(map(this.extractData), catchError(this.handleError));
    }
}